import React, { useState, useEffect } from "react";
import Hamburger from "./components/Hamburger";
import HeaderComponents from "./components/HeaderComponents";
import SideNav from "./components/SideNav";
import Home from "./Home";
import ScrollTopButton from "./components/ScrollTopButton";
import Logo from "./components/Logo";
// import { Redirect } from "found";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import LeadView from "./LeadView";
// import { useNavigate, Link } from "react-router-dom";
import backIcon from "./icons/keyboard_backspace-24px.svg";
import "./AnalysePage.css";
import Lorem from "./Lorem";
import TagContainer from "./components/TagContainer";
import PostSentimentContainer from "./components/PostSentimentContainer";
import KeywordContainer from "./components/KeywordContainer";
import searchIcon from "./icons/search-28-regular.svg";
import ChartView from "./ChartView";
import { useMediaQuery } from "react-responsive";
import Seperator from "./components/Seperator";

import {
    graphql,
    createPaginationContainer,
    createFragmentContainer,
    commitLocalUpdate,
} from "react-relay";
import environment from "./Environment";
import LeadViewContainer from "./LeadViewContainer";

import { BarChart, Bar, Brush, ReferenceLine, Legend } from "recharts";
import { useTheme } from "./contexts/ThemeContext";

function AnalysePage(props) {
    let [scrolled, setScrolled] = useState(window.pageYOffset);
    let [coords, setCoords] = useState(document.documentElement.clientHeight);
    const [showHeader, setShowHeader] = useState(false);

    const [isLeadsClick, setIsLeadsClick] = useState(true);
    const [isInsightClick, setIsInsightClick] = useState(false);
    const [isAdvancedSearchClick, setIsAdvancedSearchClick] = useState(false);
    const [isKeywordsClick, setIsKeywordsClick] = useState(false);
    const [isSentimentClick, setIsSentimentClick] = useState(false);
    const [keyTerms, setKeyTerms] = useState([]);
    const [keyWords, setKeywords] = useState([]);
    const [meanSentimentTrend, setMeanSentimentTrend] = useState("Neutral");

    const [hasPhrase, setHasPhrase] = useState("");
    const [withoutWords, setWithoutWords] = useState("");
    const [withWords, setWithWords] = useState("");
    const [scope, setScope] = useState("subscriptions");
    const [searchTime, setSearchTime] = useState("anyTime");

    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = (e) => {
        e.preventDefault();

        if (window.pageYOffset + 500) {
            setScrolled(window.pageYOffset + 500);
        }
    };

    const { email } = props.user;
    const {
        isAuthenticated,
        userId,
        isNavActivated,
        selectedSourceId,
        isParent,
        selectedNodeId,
        metaSourceName,
    } = props.settings;

    const settings = props.settings;
    const user = props.user;

    const tfidfData = props.postsTfidf;
    const sentimentScore = props.sentimentScore;
    const sentimentTrend = props.sentimentTrend;
    const keywords = props.keywords;
    const meanSentiment = props.meanSentiment;
    const sentimentPercent = props.sentimentPercent;
    useEffect(() => {
        if (meanSentiment > 0) {
            setMeanSentimentTrend("Positive");
        } else if (meanSentiment < 0) {
            setMeanSentimentTrend("Negative");
        } else {
            setMeanSentimentTrend("Neutral");
        }
    }, [meanSentiment, props.keyPhrases]);

    let sourceId_List = isParent ? selectedSourceId : selectedNodeId;
    // let orderFields = ["-created"];

    function onFindArticlesClick(e) {
        e.preventDefault();
        // navigate("/trending");
    }

    function onFindLeadsClick(e) {
        // e.preventDefault();
        // setKeyTerms(props.keyPhrases);
    }

    useEffect(() => {
        if (isLeadsClick) {
            setKeyTerms(props.keyPhrases);
        } else if (isKeywordsClick) {
            setKeywords(props.keywords);
        }
    }, [isLeadsClick, props.keyPhrases]);

    function onSearchClick(e) {
        e.preventDefault();
        setIsInsightClick(true);
        setIsLeadsClick(false);
        setIsAdvancedSearchClick(false);
        setIsKeywordsClick(false);
        setIsSentimentClick(false);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");
        });
    }

    function onLeadsClick(e) {
        e.preventDefault();
        setIsInsightClick(false);
        setIsLeadsClick(true);
        setIsAdvancedSearchClick(false);
        setIsKeywordsClick(false);
        setIsSentimentClick(false);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");
        });
    }

    function onInsightsClick(e) {
        e.preventDefault();
        setIsInsightClick(false);
        setIsLeadsClick(false);
        setIsAdvancedSearchClick(true);
        setIsKeywordsClick(false);
        setIsSentimentClick(false);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");
        });
    }

    function onKeywordsClick(e) {
        e.preventDefault();
        setIsInsightClick(false);
        setIsLeadsClick(false);
        setIsAdvancedSearchClick(false);
        setIsKeywordsClick(true);
        setIsSentimentClick(false);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");
        });
    }

    function onSentimentClick(e) {
        e.preventDefault();
        setIsSentimentClick(true);
        setIsInsightClick(false);
        setIsLeadsClick(false);
        setIsAdvancedSearchClick(false);
        setIsKeywordsClick(false);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");
        });
    }

    function onSearchButtonClick(e) {
        e.preventDefault();
    }

    const generateSettings = () => {};
    useEffect(() => {
        if (scrolled > coords) {
            setShowHeader(true);
        } else {
            setShowHeader(false);
        }
        // let showHeader = scrolled > coords ? "true" : "false";
    }, [scrolled, coords]);

    function onPhraseChange(e) {
        e.preventDefault();
        setHasPhrase(e.target.value);
    }

    function onWithoutWordsChange(e) {
        e.preventDefault();
        setWithoutWords(e.target.value);
    }

    function onWithWordsChange(e) {
        e.preventDefault();
        setWithWords(e.target.value);
    }

    function onAdvancedSearchClick(e) {
        e.preventDefault();
        let metaSourceName = "";
        if (scope === "subscriptions") {
            metaSourceName = "All Subscriptions";
        } else if (scope === "global") {
            metaSourceName = "Global Articles";
        }

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isAdvancedSearch");
            record.setValue(hasPhrase, "hasPhrase");
            record.setValue(withoutWords, "withoutWords");
            record.setValue(withWords, "withWords");
            record.setValue(scope, "searchScope");
            record.setValue(searchTime, "searchTime");
            record.setValue([], "selectedLeads");

            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");

            record.setValue(false, "isFullSpanSearchModalActivated");
            record.setValue("Advanced search results from ", "metaDescription");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue(false, "isRightNavActivated");
            record.setValue("{}", "tagData");
        });

        console.log("Phrase: " + hasPhrase);
        console.log("Without words: " + withoutWords);
        console.log("With words: " + withWords);
        console.log("scope: " + scope);
        console.log("Time: " + searchTime);

        navigate("/home");
    }

    function onOptionUpdate(e) {
        e.preventDefault();
        if (e.target.checked) {
            setScope(e.target.value);
        }
    }

    function onTimeSelectChange(e) {
        e.preventDefault();
        setSearchTime(e.target.value);
    }

    function onSearchClear(e) {
        e.preventDefault();
        setHasPhrase("");
        setWithoutWords("");
        setWithWords("");
    }

    function onBackbuttonClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");

            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
        });
        navigate("/home");
    }

    return (
        <>
            <div className={`home-view-container theme-${theme.light}`}>
                <div
                    className={`header header-fixed-true theme-${theme.light}`}
                >
                    <div
                        className={`xanalyse-header-room-${isNavActivated} theme-${theme.light}`}
                    >
                        {/* <div className={`settings-header-controls`}> */}
                        {/*     <div> </div> */}
                        {/* </div> */}
                    </div>
                </div>
                <div
                    className={`analyse-container theme-${theme.light} theme-${theme.paragraph} xtheme-${theme.border}`}
                >
                    <div
                        className={`xanalyse-header xanalyse-header-${isNavActivated}`}
                    >
                        {/* <div className="analyse-heading"> */}
                        {/*     <h1>Analytics Dashboard</h1> */}
                        {/* </div> */}
                        <div
                            className={`right-nav-category theme-${theme.light}`}
                        >
                            <button
                                onClick={onLeadsClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isLeadsClick}`}
                            >
                                {" "}
                                Topics{" "}
                            </button>

                            <button
                                onClick={onKeywordsClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isKeywordsClick}`}
                            >
                                {" "}
                                Keywords{" "}
                            </button>

                            <button
                                onClick={onSentimentClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isSentimentClick}`}
                            >
                                {" "}
                                Article Sentiment{" "}
                            </button>

                            <button
                                onClick={onSearchClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isInsightClick}`}
                            >
                                {" "}
                                Insights
                            </button>

                            <button
                                onClick={onInsightsClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isAdvancedSearchClick}`}
                            >
                                {" "}
                                Advanced Search{" "}
                            </button>
                            <Seperator />
                        </div>

                        <div className="analyse-search-content">
                            {isAdvancedSearchClick ? (
                                <div className="analyse-advanced-search">
                                    <div className="analyse-search-area">
                                        <div className="search-element">
                                            <span className="label-container">
                                                <label htmlFor="phrase">
                                                    Search Query
                                                </label>{" "}
                                            </span>
                                            <span className="input-container">
                                                <input
                                                    value={hasPhrase}
                                                    onChange={onPhraseChange}
                                                    className={`standard-textfield theme-${theme.paragraph}`}
                                                    type="text"
                                                    placeholder="Search Anything"
                                                />
                                            </span>
                                        </div>

                                        <div className="search-element">
                                            <span className="label-container">
                                                <label htmlFor="include">
                                                    With words
                                                </label>{" "}
                                            </span>
                                            <span
                                                id="include"
                                                className="input-container"
                                            >
                                                <input
                                                    value={withWords}
                                                    onChange={onWithWordsChange}
                                                    className={`standard-textfield xtheme-${theme.paragraph}`}
                                                    type="text"
                                                    placeholder="Eg: apple recipe"
                                                />
                                            </span>
                                        </div>

                                        <div className="search-element">
                                            <span className="label-container">
                                                <label htmlFor="exclude">
                                                    Without words
                                                </label>{" "}
                                            </span>
                                            <span className="input-container">
                                                <input
                                                    id="exclude"
                                                    value={withoutWords}
                                                    onChange={
                                                        onWithoutWordsChange
                                                    }
                                                    className={`standard-textfield theme-${theme.paragraph}`}
                                                    type="text"
                                                    placeholder="Eg: cake pie"
                                                />
                                            </span>
                                        </div>

                                        <div className="search-options search-element">
                                            {/* <span className="label-container"> */}
                                            {/*     <label htmlFor="scope"> */}
                                            {/*         Search Scope */}
                                            {/*     </label>{" "} */}
                                            {/* </span> */}
                                            {/* <span className="option-container input-container"> */}
                                            {/*     <div> */}
                                            {/*         <input */}
                                            {/*             id="global" */}
                                            {/*             type="radio" */}
                                            {/*             name="scope" */}
                                            {/*             value="global" */}
                                            {/*             onChange={(e) => { */}
                                            {/*                 setScope( */}
                                            {/*                     e.target */}
                                            {/*                         .value */}
                                            {/*                 ); */}
                                            {/*             }} */}
                                            {/*         /> */}
                                            {/*         <label htmlFor="global"> */}
                                            {/*             Global */}
                                            {/*         </label> */}
                                            {/*     </div> */}
                                            {/*     <div> */}
                                            {/*         <input */}
                                            {/*             id="subscriptions" */}
                                            {/*             type="radio" */}
                                            {/*             name="scope" */}
                                            {/*             value="subscriptions" */}
                                            {/*             defaultChecked */}
                                            {/*             onChange={(e) => { */}
                                            {/*                 setScope( */}
                                            {/*                     e.target */}
                                            {/*                         .value */}
                                            {/*                 ); */}
                                            {/*             }} */}
                                            {/*         /> */}
                                            {/*         <label htmlFor="subscriptions"> */}
                                            {/*             Subscriptions only */}
                                            {/*         </label> */}
                                            {/*     </div> */}
                                            {/* </span> */}
                                        </div>

                                        <div className="search-element">
                                            {/*
                                        <span className="label-container">
                                            <label htmlFor="exclude">
                                                Time
                                            </label>{" "}
                                        </span>
                                
                                        <span className="input-container">
                                            <select
                                                onChange={onTimeSelectChange}
                                                className="select-intelli-search"
                                            >
                                                <option value="pastHour">
                                                    {" "}
                                                    Past Hour{" "}
                                                </option>
                                                <option value="24Hours">
                                                    {" "}
                                                    Past 24 Hours{" "}
                                                </option>
                                                <option value="pastWeek">
                                                    {" "}
                                                    Past Week{" "}
                                                </option>
                                            </select>
                                        </span>
                                
                                */}
                                        </div>

                                        <div className="search-element">
                                            <span className="label-container"></span>
                                            <span className="input-container">
                                                <span className="action-btn-group">
                                                    <button
                                                        onClick={onSearchClear}
                                                        className="btn-action"
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        onClick={
                                                            onAdvancedSearchClick
                                                        }
                                                        className="btn-action"
                                                    >
                                                        Search
                                                    </button>
                                                </span>
                                            </span>
                                        </div>
                                    </div>{" "}
                                </div>
                            ) : null}
                            {isLeadsClick ? (
                                <div>
                                    {" "}
                                    <div className="leadview-wrapper">
                                        <div>
                                            <div className="keywords-container">
                                                {keyTerms ? (
                                                    <div>
                                                        {" "}
                                                        <TagContainer
                                                            tagList={keyTerms}
                                                            settings={settings}
                                                            user={user}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {" "}
                                                        <p>
                                                            No Key-Topics for
                                                            this Feed
                                                        </p>{" "}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {isKeywordsClick ? (
                                <div>
                                    {" "}
                                    <div className="leadview-wrapper">
                                        <div>
                                            <div className="keyterms-container">
                                                {keywords ? (
                                                    <div>
                                                        {" "}
                                                        <KeywordContainer
                                                            tagList={
                                                                props.keywords
                                                            }
                                                            settings={settings}
                                                            user={user}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {" "}
                                                        <p>
                                                            No Keywords for this
                                                            Feed
                                                        </p>{" "}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {isSentimentClick ? (
                                <div>
                                    {" "}
                                    <div className="leadview-wrapper">
                                        <div>
                                            <div className="keyterms-container">
                                                {keywords ? (
                                                    <div>
                                                        {" "}
                                                        <PostSentimentContainer
                                                            sentimentScore={
                                                                props.sentimentScore
                                                            }
                                                            settings={settings}
                                                            user={user}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {" "}
                                                        <p>
                                                            No Keywords for this
                                                            Feed
                                                        </p>{" "}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {isInsightClick ? (
                                <div className={`analyse-insights`}>
                                    {/* <h3 className={`analytics-heading`}> */}
                                    {/*     {metaSourceName} */}
                                    {/* </h3>{" "} */}
                                    <ChartView
                                        tfidfData={tfidfData}
                                        sentimentScore={sentimentScore}
                                        sentimentTrend={sentimentTrend}
                                        meanSentiment={meanSentiment}
                                        sentimentPercent={sentimentPercent}
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AnalysePage;
